export class PrimaryContact {
  name: string;
  mail: string;
  phone: string;
  note: string;
}
